module.exports = __webpack_public_path__ + "img/99.6b9e066e.png";